import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, Element } from 'react-scroll'
import { compose } from 'recompose'
import T from 'i18n-react'

import PartnerSiteTable from 'containers/Product/ProductMappingTable/index'
import SpecificationSection from 'containers/Product/ModifySpecifications/index'
import FulcrumTestSuiteConfiguration from 'containers/Product/FulcrumTestSuiteConfiguration'
import ProductSupportTeam from 'containers/Product/SupportTeam'
import ProductDetails from './ProductDetails'
import Divider from './Divider'
import NavDrawer from './NavDrawer'
import Layout from './Layout'
import Panel from './Panel'
import Card from './Card'
import ScrollNavigation from './ScrollNavigation'
import Subheading from './Subheading'
import sagas from './sagas'
import dialogHoc from 'containers/Async/AsyncDialog'

import {
  mount,
  unmount,
} from './actions'

import {
  detailsSelector
} from './selectors'
import {
  hideSpecificationsTableSelector
} from 'containers/Product/ModifySpecifications/selectors'

import {
  MODULE_NAME,
  FETCH_PRODUCT_DETAILS,
} from './constants'

import {
  PRODUCT_ROLES,
  GLOBAL_ROLES,
} from 'containers/Role/constants'

const AsyncDialog = dialogHoc([FETCH_PRODUCT_DETAILS])

const mapStateToProps = (state) => {
  return {
    details: detailsSelector(state),
    hideSpecificationsTable: hideSpecificationsTableSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    mount: (id) => dispatch(mount(id)),
    unmount: () => dispatch(unmount()),
  }
}


class Index extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    const {
      match,
      mount,
    } = this.props

    mount(match.params.id)
  }

  componentWillUnmount() {
    this.props.unmount()
  }

  render() {
    const {
      details,
      hideSpecificationsTable
    } = this.props

    const hasFulcrumTestSuiteAccess = (GLOBAL_ROLES.ADMIN_ACCESS || PRODUCT_ROLES.PRODUCT_APPLICATIONS_ENGINEER) && (details.segment === "Desktop" || details.segment === "Notebook")
    const partnerSites = T.translate('containers.product.view.index.navigation.partnerSites')
    const productSpecifications = T.translate('containers.product.view.index.navigation.specifications')
    const fulcrumTestSuiteConfiguration = T.translate('containers.product.view.index.navigation.fulcrumTestSuiteConfiguration')
    const supportTeam = T.translate('containers.product.view.index.navigation.supportTeam')
    const categories = [
      partnerSites,
      !hideSpecificationsTable && productSpecifications,
      hasFulcrumTestSuiteAccess && fulcrumTestSuiteConfiguration,
      supportTeam
    ]

    const showFts = () => {
      if (details.segment === "Desktop" || details.segment === "Notebook") {
        return (          
        <Element name={fulcrumTestSuiteConfiguration} className='element'>
          <FulcrumTestSuiteConfiguration />
        </Element>
        )
      }
    }
    return (
      <Layout>
        <NavDrawer>
          <ProductDetails
            {...details}
          />
          <Divider/>
          <Subheading>
            Navigation
          </Subheading>
          <ScrollNavigation
            containerId='scrollContainer'
            categories={categories}
          />
        </NavDrawer>
        <Panel>
          <Element name={partnerSites} className='element'>
            <PartnerSiteTable/>
          </Element>
          <Element name={productSpecifications} className='element'>
            <SpecificationSection/>
          </Element>
          {showFts()}
          <Element name ={supportTeam} className='element'>
            <ProductSupportTeam/>
          </Element>
        </Panel>
        <AsyncDialog title='Loading Product ...'/>
      </Layout>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect
)
export default enhance(Index)